module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NzAuMiIgaGVpZ2h0PSI0NzAuMiIgdmlld0JveD0iMCAwIDQ3MC4yIDQ3MC4yIj48c3R5bGU+LnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiNGRkZGRkY7c3Ryb2tlLXdpZHRoOjIwLjI1O3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1taXRlcmxpbWl0OjEwO308L3N0eWxlPjxjaXJjbGUgY2xhc3M9InN0MCIgY3g9IjIzNS4xIiBjeT0iMjM1LjEiIHI9IjIyNSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/90_finish/level-6_complete.svg
// module id = 2520
// module chunks = 2